import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blankRow: {
		id: 'native-issue-table.issue-row.blank-row.blank-row',
		defaultMessage: "We can't display this issue",
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	blankRowText: {
		id: 'native-issue-table.row.blank-row.blank-row-text',
		defaultMessage:
			'This issue cannot be opened because it may have been deleted or you do not have access to it',
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	blankRowTextWithArchiveIssue: {
		id: 'native-issue-table.row.blank-row.blank-row-text-with-archive-issue',
		defaultMessage:
			'This issue can’t be opened because it may have been archived or deleted, or you don’t have access to it.',
		description:
			'Text that shows when an issue can no longer be opened from the issue navigator, since it has been delted or archived, or user don’t have access',
	},
	blankRowTextWithArchiveIssueIssueTermRefresh: {
		id: 'native-issue-table.row.blank-row.blank-row-text-with-archive-issue-issue-term-refresh',
		defaultMessage:
			'This work item can’t be opened because it may have been archived or deleted, or you don’t have access to it.',
		description:
			'Text that shows when an issue can no longer be opened from the issue navigator, since it has been delted or archived, or user don’t have access',
	},
	tooltip: {
		id: 'native-issue-table.issue-row.blank-row.tooltip',
		defaultMessage: 'Either this issue has been deleted, or you don’t have access to it.',
		description: 'Tooltip text for blank row information icon',
	},
	blankRowIssueTermRefresh: {
		id: 'native-issue-table.row.blank-row.blank-row-issue-term-refresh',
		defaultMessage: "We can't display this work item",
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	blankRowTextIssueTermRefresh: {
		id: 'native-issue-table.row.blank-row.blank-row-text-issue-term-refresh',
		defaultMessage:
			'This work item cannot be opened because it may have been deleted or you do not have access to it.',
		description: 'Text that shows when an issue can no longer be opened from the issue list',
	},
	tooltipIssueTermRefresh: {
		id: 'native-issue-table.row.blank-row.tooltip-issue-term-refresh',
		defaultMessage: 'Either this work item has been deleted, or you don’t have access to it.',
		description: 'Tooltip text for blank row information icon',
	},
	authText: {
		id: 'native-issue-table.row.blank-row.auth-text',
		defaultMessage: 'Authenticate',
		description: 'Authenticate text label',
	},
	loginText: {
		id: 'native-issue-table.row.blank-row.login-text',
		defaultMessage: 'Log in',
		description: 'Login text label',
	},
	authRequired: {
		id: 'native-issue-table.row.blank-row.auth-required',
		defaultMessage: '{authenticateLink}to see additional information',
		description: 'Text that shows when authentication is required to view the issue',
	},
	authTooltip: {
		id: 'native-issue-table.row.blank-row.auth-tooltip',
		defaultMessage: "Some connected work items belong to a separate site that's not logged in.",
		description: 'Tooltip message for authentication required',
	},
	authButtonText: {
		id: 'native-issue-table.row.blank-row.auth-button-text',
		defaultMessage: "We can't load some connected work items",
		description: 'Button text for authentication required',
	},

	remoteLinkMissingApplinkIssueTermRefresh: {
		id: 'issues.issue-links.remote-issue-link-error.missing-applink-issue-term-refresh',
		defaultMessage: 'Failed to load because remote site is not linked',
		description: "Application link to remote instance doesn't exist",
	},

	remoteLinkMissingApplink: {
		id: 'issues.issue-links.remote-issue-link-error.missing-applink',
		defaultMessage: 'Failed to load remote issue because remote site is not linked',

		description: "Application link to remote instance doesn't exist",
	},

	remoteLinkGeneralErrorIssueTermRefresh: {
		id: 'issues.issue-links.remote-issue-link-error.general-error-issue-term-refresh',
		defaultMessage: 'Failed to load work item',
		description: 'General error message for remote issue link',
	},

	remoteLinkGeneralError: {
		id: 'issues.issue-links.remote-issue-link-error.general-error',
		defaultMessage: 'Failed to load remote issue',
		description: 'General error message for remote issue link',
	},
});
